export const APP_VERSION = '1.1.0';

//Changelog
// 1.0.1 - 2025-05-01 - Removed use of useAllClimbs and now pass route information with Activity
// 1.1.0 - 2025-06-10 - Added support for multi-gym